/**
 * Choose a viewport-safe horizontal position for an Outline tooltip.
 * The preferred position is directly left of the trigger; the right side is
 * used when the left side cannot fit the measured tooltip width.
 */
export function calculateOutlineTooltipLeft({
    anchorLeft,
    anchorRight,
    tooltipWidth,
    viewportWidth,
    gap = 10,
}) {
    const leftCandidate = anchorLeft - tooltipWidth - gap;
    const rightCandidate = anchorRight + gap;
    const maxLeft = Math.max(gap, viewportWidth - tooltipWidth - gap);

    if (leftCandidate >= gap) return leftCandidate;
    if (rightCandidate <= maxLeft) return rightCandidate;

    return Math.min(Math.max(gap, leftCandidate), maxLeft);
}

